/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaDashboard } from '../../models/criteria-dashboard';
import { FeedbackDashboardResult } from '../../models/feedback-dashboard-result';

export interface ApiRequestFeedbackGetAllFeedbackRequestPost$Params {
      body?: CriteriaDashboard
}

export function apiRequestFeedbackGetAllFeedbackRequestPost(http: HttpClient, rootUrl: string, params?: ApiRequestFeedbackGetAllFeedbackRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FeedbackDashboardResult>> {
  const rb = new RequestBuilder(rootUrl, apiRequestFeedbackGetAllFeedbackRequestPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeedbackDashboardResult>;
    })
  );
}

apiRequestFeedbackGetAllFeedbackRequestPost.PATH = '/api/request/feedback/GetAllFeedbackRequest';
